export const settings = {
  appCacheKey: 'bleiff-app',
  screenBreakpoints: {
    tablet: 576,
    desktop: 1024,
    widescreen: 1140
  },
  datepickerConfig: {
    showWeekNumbers: false,
    containerClass: 'theme-default',
    dateInputFormat: 'DD-MM-YYYY'
  },
  forms: {
    initiateOrgFormId: 'initOrganization',
    initiateOrgDraftFormId: 'initOrganizationDraft',
    declineOrgFormId: 'declineOrgFormId',
    userBlocksBalanceFormId: 'userBlocksBalance',
    initiateTradeFormId: 'initTrade',
    initiateBonusTradeFormId: 'initBonusTrade',
    bonusCertificatesBalanceFormId: 'bonusCertificatesBalance',
    createInvestorFormId: 'createInvestor',
    editOrganizationFormId: 'editOrganization',
  },
  modals: {
    initiateTradeModalId: 'initiateTradeModal',
    initiateBonusTradeModalId: 'initiateBonusTradeModal',
    tradeMembersModalId: 'tradeMembersModal',
    bonusTradeMembersModalId: 'bonusTradeMembersModal',
    declineOrgModalId: 'declineOrgModalId',
    allMembersModalId: 'allMembersModal',
    createInvestorModalId: 'createInvestorModal',
    removeOrganizationConfirmationModalId: 'removeOrganizationConfirmationModal',
    editOrganizationModalId: 'editOrganizationModal',
    removeTradeConfirmationModalId: 'removeTradeConfirmationModal',
    profileModalId: 'profileModal',

  },
  analytics: {
    numberOfLatestStaffTurnoverItemsToShow: 6,
    pieChartConfig: {
      title: {
        text: 'Fulfilment',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '14px',
          color: '#619ced',
          fontFamily: 'Lato'
        }
      },
      colors: ['#619ced', '#a9c6f3'],
      chart: {
        height: 200,
        type: 'pie',
        toolbar: { show: false },
        foreColor: '#526082'
      },
      labels: ['current certificates', 'sold certificates'],
      dataLabels: { enabled: true },
      stroke: { width: 0 },
      legend: {
        position: 'bottom'
      }
    },
    lineChartConfig: {
      title: {
        text: 'Certificate value',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '14px',
          color: '#619ced',
          fontFamily: 'Lato'
        }
      },
      colors: ['#619ced'],
      chart: {
        width: '100%',
        type: 'area',
        toolbar: { show: false }
      },
      yaxis: {
        labels: {
          formatter: value => value + ' €',
        },
      },
      dataLabels: { enabled: false },
      stroke: { curve: 'smooth' },
      tooltip: {
        x: { format: 'dd/MM/yy HH:mm' }
      }
    },
    barChartConfig: {
      title: {
        text: 'Staff turnover',
        align: 'center',
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: '14px',
          color: '#619ced',
          fontFamily: 'Lato'
        }
      },
      colors: ['#619ced'],
      chart: {
        type: 'bar',
        width: '100%',
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '30px'
        }
      },
      dataLabels: { enabled: false }
    }
  }
};
